import { trackEvent } from './firebase/analytics'; // Null-safe wrapper around Firebase Analytics logEvent


const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);

      // Optionally log performance metrics to Firebase Analytics
      getCLS((metric) => trackEvent('CLS', { value: metric.value })); // Cumulative Layout Shift
      getFID((metric) => trackEvent('FID', { value: metric.value })); // First Input Delay
      getFCP((metric) => trackEvent('FCP', { value: metric.value })); // First Contentful Paint
      getLCP((metric) => trackEvent('LCP', { value: metric.value })); // Largest Contentful Paint
      getTTFB((metric) => trackEvent('TTFB', { value: metric.value })); // Time to First Byte
    });
  }
};

export default reportWebVitals;
